import { NavLink } from 'react-router-dom';
import withRewrite from 'app/hoc/withRewrite';

export default withRewrite(NavLink);
